import { ListItinerantsTemplate } from "../../Templates/ListItinerantsTemplate";

export const ListItinerants = () => {
  return <ListItinerantsTemplate />;
};
